export const addHero = (hero) => {
  const title = document.querySelector('[data-post-hero-title]');
  const image = document.querySelector('[data-post-hero-image]');
  const date = document.querySelector('[data-post-hero-date]');

  title.innerHTML = hero.title;
  date.innerHTML = hero.date;
  image.setAttribute('data-src', hero.image)
  image.setAttribute('alt', hero.title)
}